export default "__VITE_ASSET__Ccjiy02L__"